import { isSameMonth, startOfMonth } from 'date-fns';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { IconTooltipButton } from '@/components/common/IconTooltipButton';
import { Button } from '@/components/ui/button';
import { shiftMonth } from '../utils/holidayCalendar';
import { HolidayMonthPicker } from './HolidayMonthPicker';

interface HolidayMonthSwitcherProps {
  monthStart: Date;
  monthLabel: string;
  onChangeMonth: (monthStart: Date) => void;
}

export function HolidayMonthSwitcher({
  monthStart,
  monthLabel,
  onChangeMonth,
}: HolidayMonthSwitcherProps) {
  const isCurrentMonth = isSameMonth(monthStart, new Date());

  return (
    <div className="inline-flex h-10 items-center rounded-xl border border-primary/15 bg-card px-1 shadow-xs">
      <IconTooltipButton
        icon={ChevronLeft}
        label="Previous month"
        onClick={() => onChangeMonth(shiftMonth(monthStart, -1))}
      />
      <HolidayMonthPicker
        monthStart={monthStart}
        monthLabel={monthLabel}
        onChangeMonth={onChangeMonth}
      />
      <IconTooltipButton
        icon={ChevronRight}
        label="Next month"
        onClick={() => onChangeMonth(shiftMonth(monthStart, 1))}
      />
      <span className="mx-1 h-5 w-px bg-border" aria-hidden />
      <Button
        type="button"
        variant="ghost"
        size="sm"
        disabled={isCurrentMonth}
        onClick={() => onChangeMonth(startOfMonth(new Date()))}
        className="text-primary"
      >
        This month
      </Button>
    </div>
  );
}
